import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RtUICoreOverlayModule } from '../../core/overlay/overlay.module';
import { IconModule } from '../icon/icon.module';
import { TooltipInnerComponent } from './tooltip-inner.component';
import { TooltipComponent } from './tooltip.component';
import { RtTooltip } from './tooltip.directive';

@NgModule({
  imports: [CommonModule, RtUICoreOverlayModule, IconModule],
  declarations: [RtTooltip, TooltipComponent, TooltipInnerComponent],
  exports: [TooltipComponent, RtTooltip, TooltipInnerComponent],
  entryComponents: [TooltipComponent],
})
export class TooltipModule {}
export { TooltipInnerComponent, TooltipPosition } from './tooltip-inner.component';
export { TooltipComponent } from './tooltip.component';
export { RtTooltip } from './tooltip.directive';
